import * as React from 'react';

import { TRIAL_INCLUDES_SUMMARY, TRIAL_UNLOCK_NOTE } from '../trial';
import { CheckBullet } from './pricing-card';

const INCLUDED_ITEMS = [
  'No watermark',
  'Unlimited free local renders',
  'High-quality AI voices',
  'AI avatars',
  'Auto-translation',
  'Cancel anytime'
];

const TRUST_ITEMS = [
  'Free for 7 days — cancel before it ends, pay nothing',
  'No lock-in — cancel anytime',
  'One free trial per workspace'
];

/** "Every plan includes" strip + trust row shown below the pricing cards. */
export function PricingIncludes(): React.JSX.Element {
  return (
    <div className="container space-y-8 pb-4">
      <div className="mx-auto max-w-4xl rounded-2xl border bg-card px-6 py-8 shadow-xs sm:px-10">
        <h2 className="text-center text-sm font-semibold uppercase tracking-widest text-muted-foreground">
          Every paid plan includes
        </h2>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
          {INCLUDED_ITEMS.map((item) => (
            <li
              key={item}
              className="flex items-center gap-2 text-sm font-medium"
            >
              <CheckBullet className="mt-0" />
              {item}
            </li>
          ))}
        </ul>
        <p className="mt-5 text-center text-xs text-muted-foreground">
          Free trial includes {TRIAL_INCLUDES_SUMMARY}. {TRIAL_UNLOCK_NOTE}
        </p>
      </div>
      <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-center text-xs text-muted-foreground sm:text-sm">
        {TRUST_ITEMS.map((item, index) => (
          <React.Fragment key={item}>
            {index > 0 && (
              <span
                aria-hidden="true"
                className="hidden sm:inline"
              >
                ·
              </span>
            )}
            <span>{item}</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
